import {TagService} from '../services/tag-service.service';
import {Tag} from '../admin/tag/model/tag';
import { Component } from '@angular/core';
import {UserService} from '../services/user.service';
import {Login} from '../services/user.service';
import { Observable, Subscription } from 'rxjs/Rx';
import {ActivatedRoute, Router } from '@angular/router';
import {CookieService} from 'ng2-cookies';

@Component({
  host: {
    '(document:keydown)': 'keyDown($event)',
  }, 

  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent { 
  /*
private LOGO = require("../../assets/donut-7.png");
private LOGO1 = require("../../assets/donut.png");
private bkgrnd = require("../../assets/hitech.jpg");
private tnd = require("../../assets/tnd.png");
private glb = require("../../assets/glb2.png");
   */
  public hex = require("../../assets/hex.jpg");
  pwdHash: string;
  email: string;
  passwd: string;
  searchText = "";
  page = "";
  hashTag = "";
  gwt = "";
  base = "";
  source = "";
  private model = new Tag('', '', '', '');
  cookies = false;
  guser = "";
  timeout = 1000;
  maxretry = 6;

  constructor(private tagService: TagService, private activatedRoute: ActivatedRoute,private userSVC: UserService, private router: Router, private loginInfo : Login, private _cookieService:CookieService) {loginInfo = new Login();}

  setCookie(key: string, value: string){
    this._cookieService.set(key, value);
    key = this._cookieService.get(key);
    if(!key) {
      this.cookies = false;
    }  else {
      this.cookies = true;
    }
  }


  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.gwt = params['g'] || "";
      this.hashTag = params['h'] || "";
      this.base = params['b'] || "";
      this.source = params['s'] || "";
      this.guser = params['n'] || "";
      this.searchText = params['q'] || "";
    });

    this.setCookie("ctest", "ctest"); 
    if(!this.cookies){
      alert("Please, enable cookies!");
    }

    if(this.gwt !== undefined && this.gwt !== "" && !this.userSVC.authUser.email) { 
      if (this.guser !== "yes") {
        this.relogin();
      }
    }
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  login(){
    if(this.gwt !== undefined && this.gwt !== "" && this.userSVC.authUser.email) { 
      if (this.guser === "yes") {
        this.router.navigate(['/admin/search'],  { queryParams: { q : this.searchText}});
      }
    }

    if(!this.cookies){
      return;
    }

    if (!this.validateEmail(this.email)) {
      alert("Username or, Password is incorrect!. Please, try again or click on 'Forgot Password?' below. Thank you!");
      return;
    }

    this.loginInfo.email = this.email;
    this.loginInfo.passwd = this.passwd;
    if (this.email && this.passwd) {
      if(this.gwt !== undefined && this.gwt !== "") { 
        this.loginInfo.sessionId = this.gwt; 
      }

      this.gwt == "";
      this.userSVC.login(this.loginInfo);
      var retry = 0;
      while (!this.userSVC.authUser.email && retry < this.maxretry) {
        setTimeout(()=>{
          if (this.userSVC.authUser.email && this.gwt === "") {
            this.gwt = this.userSVC.authUser.sessionId;
            this.setCookie("gwt", this.userSVC.authUser.sessionId);
            this.router.navigate(['/admin/search'],  { queryParams: { q : this.searchText}});
          }

          if (!this.userSVC.authUser.email && retry === this.maxretry - 1) {
            alert("Username or, Password is incorrect!. Please, try again or click on 'Forgot Password?' below. Thank you!");
          }
        }, retry*this.timeout);
        retry++;
      }
    }
  }

  signup(){
    this.router.navigate(['signup'],  { queryParams: { g : this.gwt}});
  }

  forgot(){
    this.router.navigate(['forgot'],  { queryParams: { g : this.gwt}});
  }

  keyDown(event: any) {
    switch (event.keyCode) {
      case 13:
        this.login()
        event.preventDefault();
        break;
    }
    return;
  }

  relogin(){
    setTimeout(()=>{
      this.loginInfo.email = this.userSVC.authUser.email;
      this.loginInfo.sessionId = this.gwt;
      this.userSVC.relogin(this.loginInfo);
    }, 1000);
    setTimeout(()=>{
      if (this.userSVC.authUser.sessionId) {
        this.setCookie("gwt", this.userSVC.authUser.sessionId);
      }
    }, 1800);
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts